import {DatePipe} from "@angular/common";
import {HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi} from "@angular/common/http";
import {NgModule} from "@angular/core";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {BrowserModule} from "@angular/platform-browser";
import {AngularMaterialModule, MyDateAdapter} from "./angular-material.module";
import {AppRoutingModule} from "./app-routing.module";
import {AppComponent} from "./app.component";
import {HttpConfigInterceptor} from "./interceptor/httpconfig.interceptor";
import {HomepageComponent} from "./component/landing/homepage/homepage.component";
import {MainPageComponent} from "./component/landing/main-page/main-page.component";
import {NotAllowedComponent} from "./component/landing/not-allowed/not-allowed.component";
import {PreLandingComponent} from "./component/landing/pre-landing/pre-landing.component";
import {ModalErrorComponent} from "./modal/modal-gestioneErrori/modal-error/modal-error.component";
import {ModalSuccessComponent} from "./modal/modal-gestioneErrori/modal-success/modal-success.component";
import {AuthGuard} from "./auth/auth.guard";
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from "@angular/material/core";
import {GenericConfirmationComponent} from "./modal/generic-confirmation/generic-confirmation.component";
import {EventLandingComponent} from './component/event/event-landing/event-landing.component';
import {EventNewComponent} from './component/event/event-new/event-new.component';
import {EventSlotsModalComponent} from "./modal/modal-event/event-slots-modal/event-slots-modal.component";
import {ReservationReportComponent} from "./component/reservation/reservation-report/reservation-report.component";
import {ReservationLandingComponent} from './component/reservation/reservation-landing/reservation-landing.component';
import {EventEditComponent} from './component/event/event-edit/event-edit.component';
import {MAT_MOMENT_DATE_ADAPTER_OPTIONS, MomentDateAdapter} from "@angular/material-moment-adapter";
import {MY_FORMATS} from "./constants/datapicker";
import {ReservationAnotherComponent} from './component/reservation/reservation-another/reservation-another.component';
import {MdrDashboardComponent} from './component/mdr/mdr-dashboard/mdr-dashboard.component';
import {MdrRequestsToManageComponent} from './component/mdr/mdr-requests-to-manage/mdr-requests-to-manage.component';
import {MdrRequestHistoryComponent} from './component/mdr/mdr-request-history/mdr-request-history.component';
import {MdrPassengersModalComponent} from './modal/modal-mdr/mdr-passengers-modal/mdr-passengers-modal.component';
import {RestaurantsTabComponent} from './component/mdr/restaurants/restaurants-tab.component';
import {RestaurantConfigDialogComponent} from './modal/modal-mdr/restaurant-config-dialog/restaurant-config-dialog.component';
import {MatMenuModule} from '@angular/material/menu';
import {SpinnerModule} from "./_components/spinner/spinner.module";
import {MatButtonToggleModule} from "@angular/material/button-toggle";
import {ShipSelectionDialogComponent} from "./component/reservation/reservation-dialog/ship-selection-dialog.component";
import {DateValidatorDirective} from "./component/event/date-validator";
import {SortDatesPipe} from "./component/event/sort-dates.pipe";
import {TimeMaskDirective} from "./modal/modal-mdr/restaurant-config-dialog/time-mask.directive";


@NgModule({
  declarations: [
    AppComponent,
    HomepageComponent,
    MainPageComponent,
    NotAllowedComponent,
    ModalSuccessComponent,
    ModalErrorComponent,
    GenericConfirmationComponent,
    PreLandingComponent,
    EventLandingComponent,
    EventNewComponent,
    EventSlotsModalComponent,
    ReservationReportComponent,
    ReservationLandingComponent,
    ShipSelectionDialogComponent,
    EventEditComponent,
    ReservationAnotherComponent,
    MdrDashboardComponent,
    MdrRequestsToManageComponent,
    MdrRequestHistoryComponent,
    RestaurantsTabComponent,
    RestaurantConfigDialogComponent,
    TimeMaskDirective,
    MdrPassengersModalComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    AngularMaterialModule,
    MatMenuModule,
    SpinnerModule,
    MatButtonToggleModule,
    DateValidatorDirective,
    SortDatesPipe
  ],
  providers: [
    provideHttpClient(
      withInterceptorsFromDi()
    ),
    DatePipe,
    AuthGuard,
    { provide: HTTP_INTERCEPTORS, useClass: HttpConfigInterceptor, multi: true },
    { provide: MAT_DATE_LOCALE, useValue: 'it' },
    { provide: DateAdapter, useClass: MyDateAdapter },
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
    },

    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ],
  bootstrap: [AppComponent],
})
export class AppModule { }
